import { makeAutoObservable, runInAction } from "mobx";
import { PendingStatistics } from "interfaces";
import { getPendingStatistics } from "services";

export class PendingStatisticsStore {
  public indicators: PendingStatistics = {
    companies: {},
    contracts: {},
    requests: {},
    total: 0,
  };

  public isLoading = false;
  public error: Error | null = null;
  private intervalId: NodeJS.Timeout | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  public async fetchIndicators() {
    this.isLoading = true;
    this.error = null;

    try {
      const response = await getPendingStatistics();
      runInAction(() => {
        this.indicators = response;
        this.isLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.error = error as Error;
        this.isLoading = false;
      });
    }
  }

  public startPolling(interval = 30000) {
    this.fetchIndicators();
    runInAction(() => {
      this.intervalId = setInterval(() => this.fetchIndicators(), interval);
    });
  }

  public stopPolling() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      runInAction(() => {
        this.intervalId = null;
      });
    }
  }
}
